import React, { useEffect, useState } from "react";
import { Formik } from "formik";
import * as Yup from "yup";
import { useParams } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import { notify, notifyWarning } from "../Toastmessage/Toastmessage";
import moment from "moment";
import { CurrierPriceService } from "../../../services/currier-price-service";
import { CurrierCompanyService } from "../../../services/currier-company-service";
import { LocationService } from "../../../services/locations-service";

export const Currierpriceeditcontent = (props) => {
  const format2 = "YYYY-MM-DD";

  const { currierPriceID } = useParams();

  const [submitloading, setSubmitLoading] = useState(true);

  const [ companies, setCompanies ] = useState([]);
  const [ districts, setDistricts ] = useState([]);

  const currierCompanies = async () => {
    try{
      const result = await CurrierCompanyService.currierCompanies();
      setCompanies(result);
    }catch(err){
      if (err.response.data.message !== undefined) {
        notifyWarning(err.response.data.message);
      } else {
        notifyWarning("Something Wrong");
      }
    }
  }

  const allDistricts = async () => {
    try{
      const result = await LocationService.districtDetails();
      setDistricts(result);
    }catch(err){
      if (err.response.data.message !== undefined) {
        notifyWarning(err.response.data.message);
      } else {
        notifyWarning("Something Wrong");
      }
    }
  }

  const onSubmitForm = async (
    values,
    { resetForm, setErrors, setStatus, setSubmitting, setFieldValue }
  ) => {
    //todo extra validations
    setSubmitLoading(false);

    try {
      await CurrierPriceService.currierPriceUpdate(
        currierPriceID,
        values
      );

      setSubmitLoading(true);
      notify("Currier price successfully updated");
    } catch (err) {
      setSubmitLoading(true);
      //show error toast
      if (err.response.data.message !== undefined) {
        notifyWarning(err.response.data.message);
      } else {
        notifyWarning("Something Wrong");
      }
    }
  };

  useEffect(() => {
    CurrierPriceSearchID();
      currierCompanies();
      allDistricts();
  }, []);

  const [currierPriceInfo, setCurrierPriceInfo] = useState({
    company_id: "",
    district: "",
    price: "",
  });

  const CurrierPriceSearchID = async () => {
    try {
      const result = await CurrierPriceService.currierPriceDetailsID(currierPriceID);

      const info = {};

      const currierPricedata = result;

      info.company_id = currierPricedata.company_id;
      info.district = currierPricedata.district;
      info.price = currierPricedata.price;

      setCurrierPriceInfo(info);
    } catch (err) {
      //toast
      if (err.response.data.message !== undefined) {
        notifyWarning(err.response.data.message);
      } else {
        notifyWarning("Something Wrong");
      }
    }
  };

  return (
    <div className="ms-content-wrapper">
      <div>
        <ToastContainer />
      </div>
      <div className="row">
        <div className="col-xl-12 col-md-12">
          <div className="ms-panel ms-panel-fh">
            <div className="ms-panel-header">
              <h6>Edit Currier Price</h6>
            </div>
            <div className="ms-panel-body">
              <Formik
                enableReinitialize={true}
                initialValues={{
                  company_id: currierPriceInfo.company_id,
                  district: currierPriceInfo.district,
                  price: currierPriceInfo.price,
                }}
                validationSchema={Yup.object().shape({
                  company_id: Yup.string().required("Required"),
                  district: Yup.string().required("Required"),
                  price: Yup.string().required("Required"),
                })}
                onSubmit={onSubmitForm}
              >
                {({
                  errors,
                  handleBlur,
                  handleChange,
                  touched,
                  values,
                  submitForm,
                  isValid,
                }) => (
                  <div>
                    <div className="form-row">
                      <div className="col-md-6 mb-3">
                        <label htmlFor="validationCustom08">Company</label>
                        <div className="input-group">
                          <select
                            name="company_id"
                            className="form-control"
                            id="companyId"
                            onChange={handleChange}
                            onBlur={handleBlur}
                            value={values.company_id}
                            disabled={true}
                          >
                          {companies.map((company) => {
                            return (
                              <option key={company.id} value={company.id}>{company.company}</option>
                              )
                            })}
                          </select>
                        </div>
                        <div style={{ color: "red", fontSize: "12px" }}>
                          {touched.code && errors.company_id}
                        </div>
                      </div>
                      <div className="col-md-6 mb-3">
                        <label htmlFor="validationCustom08">District</label>
                        <div className="input-group">
                          <select
                            name="district"
                            className="form-control"
                            id="districtid"
                            onChange={handleChange}
                            onBlur={handleBlur}
                            value={values.district}
                          >
                            {districts.map((district) => {
                            return (
                              <option key={district.id} value={district.name_en}>{district.name_en}</option>
                              )
                            })}
                            
                          </select>
                        </div>
                        <div style={{ color: "red", fontSize: "12px" }}>
                          {touched.title && errors.title}
                        </div>
                      </div>
                    </div>
                    <div className="form-row">
                      <div className="col-md-6 mb-3">
                        <label htmlFor="validationCustom08">Price</label>
                        <div className="input-group">
                          <input
                            name="price"
                            type="text"
                            className="form-control"
                            id="priceId"
                            required
                            onChange={handleChange}
                            onBlur={handleBlur}
                            value={values.price}
                          />
                        </div>
                        <div style={{ color: "red", fontSize: "12px" }}>
                          {touched.price && errors.price}
                        </div>
                      </div>
                    </div>

                    <div className="col-md-2" hidden={submitloading}>
                      <div className="spinner spinner-7">
                        <div className="bounce1" />
                        <div className="bounce2" />
                        <div className="bounce3" />
                      </div>
                    </div>
                    <div
                      className="form-row"
                      style={{ display: "flex", justifyContent: "flex-end" }}
                    >
                      <button
                        type="button"
                        className="btn btn-primary shadow-none"
                        onClick={submitForm}
                      >
                        Update
                      </button>
                    </div>
                  </div>
                )} 
              </Formik>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Currierpriceeditcontent;
